
      import ToBeConfirmed from './to-be-confirmed.vue'
      import type { App, Plugin } from 'vue'

      export const ToBeConfirmedPlugin: Plugin = {
        install(app: App) {
          app.component('ToBeConfirmed', ToBeConfirmed)
        },
      }
      export { ToBeConfirmed }
      